/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect, useRef } from 'react';
import { bool, func, node, object } from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

const styles = (theme) => ({
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
  },
  modal: {
    backgroundColor: '#fff',
    borderRadius: theme.spacing(1),
    boxShadow: theme.shadows[5],
    padding: theme.spacing(4),
    outline: 'none',
    maxHeight: '80%',
    overflowY: 'auto',
  },
  closeButton: {
    border: 'none !important',
    backgroundColor: 'transparent !important',
    color: 'black !important',
    minWidth: 'auto !important',
    marginRight: '0px !important',
    marginBottom: '20px !important',
    padding: '0px !important',
    '& svg': {
      fontSize: '28px',
    },
  },
});

const CustomModal = ({ open, children, onClose, classes, modalSize, ...rest }) => {
  const modalRef = useRef(null);

  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
      const handleOutsideClick = (e) => {
        if (modalRef.current && !modalRef.current.contains(e.target)) {
          onClose();
        }
      };
      document.addEventListener('mousedown', handleOutsideClick);
      return () => {
        document.removeEventListener('mousedown', handleOutsideClick);
        document.body.style.overflow = 'unset';
      };
    }
  }, [open, onClose]);

  if (!open) return null;

  const sizes = {
    xs: 444,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920,
  };

  return (
    <div className={classes.modalOverlay} {...rest}>
      <div ref={modalRef} className={classes.modal} style={{ maxWidth: `${sizes[modalSize]}px` }}>
        <Button className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </Button>
        <div>{children}</div>
      </div>
    </div>
  );
};

CustomModal.defaultProps = {
  modalSize: 'sm'
};

CustomModal.propTypes = {
  open: bool.isRequired,
  children: node.isRequired,
  onClose: func.isRequired,
  classes: object.isRequired,
  modalSize: object,
};

export default withStyles(styles)(CustomModal);
